import './review-sections.css'

interface Insight {
  insight: string
  evidence: string
  category: string
  severity: string
  recurring: boolean
  prior_cycle_note: string | null
}

interface Pattern {
  pattern: string
  occurrences: number
  recommendation: string
}

interface InsightsData {
  insights: Insight[]
  patterns: Pattern[]
}

interface Props {
  data: InsightsData
}

export default function InsightsSection({ data }: Props) {
  return (
    <div>
      <p className="section-hint">
        Key takeaways and recurring patterns detected across your review history.
      </p>

      {(data.insights || []).map((insight, i) => (
        <div key={i} className={`review-card severity-${insight.severity}`}>
          <div className="review-card-header">
            <span className="review-card-title">{insight.insight}</span>
            <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
              <span className="bsc-badge" style={{ background: '#f5f5f5', color: '#666' }}>
                {insight.category}
              </span>
              {insight.recurring && (
                <span className="recurring-badge">Recurring</span>
              )}
            </div>
          </div>
          <p className="review-card-body">{insight.evidence}</p>
          {insight.prior_cycle_note && (
            <p style={{ fontSize: 12, color: '#e65100', marginTop: 6, fontStyle: 'italic' }}>
              Prior cycle: {insight.prior_cycle_note}
            </p>
          )}
        </div>
      ))}

      {(data.patterns || []).length > 0 && (
        <div style={{ marginTop: 16 }}>
          <h4 style={{ fontSize: 14, marginBottom: 8 }}>Detected Patterns</h4>
          {data.patterns.map((pattern, i) => (
            <div key={i} className="pattern-card">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                <strong style={{ fontSize: 13 }}>{pattern.pattern}</strong>
                <span className="pattern-count">{pattern.occurrences} occurrences</span>
              </div>
              <p className="review-card-body">{pattern.recommendation}</p>
            </div>
          ))}
        </div>
      )}

      {(!data.insights || data.insights.length === 0) && (!data.patterns || data.patterns.length === 0) && (
        <p style={{ fontSize: 13, color: '#666', fontStyle: 'italic' }}>
          No insights available for this cycle.
        </p>
      )}
    </div>
  )
}
